import { Directive, Input } from '@angular/core';

import * as ɵngcc0 from '@angular/core';
class AwComponent {
}
AwComponent.ɵfac = function AwComponent_Factory(t) { return new (t || AwComponent)(); };
AwComponent.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: AwComponent, inputs: { automationValue: "automationValue" } });
AwComponent.propDecorators = {
    automationValue: [{ type: Input }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(AwComponent, [{
        type: Directive
    }], null, { automationValue: [{
            type: Input
        }] }); })();

export { AwComponent };

//# sourceMappingURL=aw-ads-components-aw-parent.js.map